export default function reducerAbandonedCarts(state = {}, action) {
  switch (action.type) {
    case 'GET_ABANDONED_CARTS':
      return {
        ...state,
        abandonedCarts: action.payload.data,
      }
    default:
      return state
  }
}
